import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import { runInAction } from 'mobx';

export class UsageSummaryStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      chartChanged: false,
      textChanged: false,
      // routerData: [],
      // uniqueNames: [],
    });
    this.start = '';
    this.end = '';
    this.tenantIds = [];
    this.routerData = [];
    this.uniqueNames = [];
    this.renderHighchart = false;
    this.summaryFixedDevice = [];

  }

  setData(task, value) {
    this.textChanged = !this.textChanged;
    this.renderHighchart = false;
    this[task] = value;
  }

  setRenderHighchart(status = true) {
    this.renderHighchart = status;
  }

  async getSummaryRouter(start, end, tenantIds,) {
    // const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    if (tenantIds && tenantIds.length > 0) {
      this.loading = true;
      try {
        let url = `${config.api.url}/${config.api.version}/systemsummary/router/status?tenantIds=${tenantIds}&startDate=${start}&endDate=${end}`;
        const res = await rp
          .get({
            uri: url,
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res && res.statusCode === 200) {
          runInAction(() => {
            const resp = res.body;
            this.routerData = this.calculateRouter(resp, start, end);
            this.chartChanged = !this.chartChanged;
          });
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        }
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  async getFixedEmergencySummary(date, tenantIds, timeRange, type) {
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    let queryOption = {};
    queryOption = {
      timeRange: timeRange,
      tenantIds: tenantIds,
      date: dateFormate,
    };
    runInAction(() => {
      this.summaryFixedDevice = [];
    });
    if (tenantIds && tenantIds.length > 0) {
      this.loading = true;
      try {
        let url = `${config.api.url}/${config.api.version}/systemsummary/fixedbutton/${type}`;
        const res = await rp
          .get({
            uri: url,
            qs: queryOption,
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res && res.statusCode === 200) {
          const resp = res.body;
          this.summaryFixedDevice = resp;
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        }
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  getUTCDateTime = (dateTime) => {
    return dateTime.getTime() - dateTime.getTimezoneOffset() * 60 * 1000;
  };

  calculateRouter = (data, start, end) => {
    let routerResult = [];

    let startDate = new Date(`${start} 00:00`);
    let endDate = new Date(`${end} 23:59`);

    const mockBegin = {
      x: this.getUTCDateTime(startDate),
      x2: this.getUTCDateTime(startDate) + 1,
    };
    const mockEnd = {
      x: this.getUTCDateTime(endDate),
      x2: this.getUTCDateTime(endDate),
    };

    routerResult.push(mockBegin);

    // get router name
    let yAxisDatas = data.map((d) => {
      return {
        serial: d.router.serial,
        name: `${d.router.place}-${d.router.name}` 
      };
    });


    yAxisDatas = yAxisDatas.sort((a, b) => {
      return a.name.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    });

    yAxisDatas.forEach((data, index) => {
      routerResult.push({
        y: index,
        x: this.getUTCDateTime(startDate),
        x2: this.getUTCDateTime(startDate) + 1,
        serial: data?.serial ?? '',
        name: data?.name ?? '',
      });
    });

    this.uniqueNames = yAxisDatas.map((d) => d.name);
    const finalyAxisDatas = yAxisDatas.map((d) => d.serial);

    // set data
    if (data.length > 0) {
      data.forEach((val) => {
        if (val.status.daily.length > 0) {
          val.status.daily.forEach((d) => {
            if (d.status === 'CONNECTED') {
              routerResult.push({
                y: finalyAxisDatas.indexOf(val.router.serial),
                x: this.getUTCDateTime(new Date(d.start)),
                x2: this.getUTCDateTime(new Date(d.end)),
                serial: val?.router?.serial,
                name: val?.router?.name,
                place: val?.router?.place,
                referenceNumber: val?.router?.referenceNumber,
              });
            }
            return d;
          });
        }
      });
    }
    routerResult.push(mockEnd);

    return routerResult;
  };
}

export default new UsageSummaryStore();
